import { render, staticRenderFns } from "./DayOfTheWeek.vue?vue&type=template&id=0be90f46&scoped=true&"
import script from "./DayOfTheWeek.vue?vue&type=script&lang=js&"
export * from "./DayOfTheWeek.vue?vue&type=script&lang=js&"
import style0 from "./DayOfTheWeek.vue?vue&type=style&index=0&id=0be90f46&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be90f46",
  null
  
)

export default component.exports